module.exports = __webpack_public_path__ + "img/icon1.38ac59ba.svg";